import React from 'react';
import { Form, Field } from 'react-final-form';
import { companySitesSelector, messagesSelector } from '../../../helpers/selectors';
import { connect } from 'react-redux';
import { trimFields } from '../../../utils/utils';
import { genericAddressField } from '../../forms/newFields';
import {
  touchOnChangeField,
  DatePickerField,
  TimePickerField
} from '../../forms/fields';
import { FormattedMessage } from 'react-intl';
import _isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import config from '../../../constants/config';
import _isString from 'lodash/isString';

function setLocationError(values, errors, messages) {
  const { location } = values;

  if (_isEmpty(location)) {
    errors.location = messages['error.form.required'];
  } else if (_isString(location.value)) {
    errors.location = messages['error.form.suggestion.address.required'];
  }
}

function setEmptyDatesError(values, errors, messages) {
  if (!values.startDate) {
    errors.startDate = messages['error.form.required'];
  }

  if (!values.startTime) {
    errors.startTime = messages['error.form.required'];
  }

  if (!values.endDate) {
    errors.endDate = messages['error.form.required'];
  }

  if (!values.endTime) {
    errors.endTime = messages['error.form.required'];
  }
}

function setMinDurationError(values, errors, messages) {
  const { startDate, startTime, endDate, endTime } = values;

  if (startDate && startTime && endDate && endTime) {
    const start = startDate + 'T' + startTime;
    const end = endDate + 'T' + endTime;
    const datesDiff = moment(end).diff(start, 'minutes');

    if (datesDiff < config.minimumBookingDurationMinutes) {
      errors.endTime = messages['error.form.required'];
    }
  }
}

function setStartDatePastError(values, errors, messages) {
  const { startDate, startTime } = values;

  if (startDate && startTime) {
    if (moment().diff(startDate + 'T' + startTime, 'minutes') > 0) {
      errors.startTime = messages['error.form.required'];
    }
  }
}

function setEndBeforeStartError(values, errors, messages) {
  const { startDate, endDate } = values;

  if (startDate && endDate) {
    if (moment(endDate).diff(startDate, 'days') < 0) {
      errors.startDate = messages['error.form.required'];
      errors.endDate = messages['error.form.required'];
    }
  }
}

const validate = (values, props) => {
  const errors = {};
  const { messages } = props;

  values = trimFields({ ...values });

  setEmptyDatesError(values, errors, messages);
  setEndBeforeStartError(values, errors, messages);
  setMinDurationError(values, errors, messages);
  setStartDatePastError(values, errors, messages);
  setLocationError(values, errors, messages);

  return errors;
};

const GenericAddressField = touchOnChangeField(genericAddressField);

function isSameDay(values = {}) {
  const { startDate, endDate } = values;

  return moment(startDate).isSame(endDate, 'day');
}

function BookingEditPopupForm({ companySites, messages, initialValues, onSubmit }) {
  return (
    <Form
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={(values) => validate(values, { messages })}
    >
      {({ handleSubmit, values }) => {
        const { startDate, startTime } = values || {};

        return (
          <form className="booking-edit-popup-form" noValidate onSubmit={handleSubmit}>
            <div className="scope-location-wrap">
              <Field
                name="location"
                component={GenericAddressField}
                label={messages['generic.address']}
                placeholder={messages['generic.location.search.placeholder']}
                fixtures={companySites}
                fixturesTitle={messages['generic.location.fixture.label']}
                historyTitle={messages['generic.location.history.label']}
                searchHistoryEnabled
              />
            </div>
            <div className="scope-dates-wrap">
              <div className="scope-date-time-wrap">
                <Field name="startDate" component={DatePickerField} />
                <Field
                  name="startTime"
                  startDate={startDate}
                  component={TimePickerField}
                />
              </div>
              <div className="scope-date-time-wrap">
                <Field
                  name="endDate"
                  isEndDate
                  component={DatePickerField}
                  disabledUntil={startDate}
                />
                <Field
                  name="endTime"
                  isEndTime
                  component={TimePickerField}
                  isSameDay={isSameDay(values)}
                  startTime={startTime}
                />
              </div>
            </div>
            <div className="scope-action-wrap">
              <button type="submit" className="generic-submit-button primary-btn">
                <FormattedMessage id="action.search.update.bookings" />
              </button>
            </div>
          </form>
        );
      }}
    </Form>
  );
}

const mapStateToProps = (state) => {
  return {
    messages: messagesSelector(state),
    companySites: companySitesSelector(state)
  };
};

export default connect(mapStateToProps)(BookingEditPopupForm);
